module.exports = __webpack_public_path__ + "static/media/folder-open.05b1bdd3.svg";